module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "page-section"
  }, [_c('div', {
    staticClass: "order-box"
  }, [_c('div', {
    staticClass: "order-section"
  }, [_c('a', {
    staticClass: "affix-trigger",
    attrs: {
      "name": "sizes"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "hero-title has-text-centered"
  }, [_vm._v("Choose a size")]), _vm._v(" "), _c('product-select')], 1), _vm._v(" "), _c('div', {
    staticClass: "order-section color-section"
  }, [_c('a', {
    staticClass: "affix-trigger",
    attrs: {
      "name": "colors"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "hero-title has-text-centered"
  }, [_vm._v("Choose a color")]), _vm._v(" "), _c('color-select')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "has-text-centered"
  }, [(_vm.selectedProduct !== null && _vm.selectedColor !== null) ? _c('button', {
    staticClass: "button btn-success",
    on: {
      "click": function($event) {
        return _vm.addToCart()
      }
    }
  }, [_vm._v("\n                Add to cart\n            ")]) : _c('button', {
    staticClass: "button"
  }, [_vm._v("\n                Select a\n                "), (_vm.selectedProduct === null) ? _c('span', [_vm._v("size")]) : _vm._e(), _vm._v(" "), (_vm.selectedProduct === null && _vm.selectedColor === null) ? _c('span', [_vm._v("and")]) : _vm._e(), _vm._v(" "), (_vm.selectedColor === null) ? _c('span', [_vm._v("color")]) : _vm._e()]), _vm._v(" "), (_vm.cartItems.length > 0) ? _c('div', [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "cart-listing",
    staticStyle: {
      "display": "inline-block",
      "max-width": "700px"
    }
  }, _vm._l((_vm.cartItems), function(item) {
    return _c('div', {
      staticClass: "cart-item"
    }, [_c('div', {
      staticClass: "cart-control",
      on: {
        "click": function($event) {
          return _vm.removeFromCart(item.id)
        }
      }
    }, [_c('icons', {
      attrs: {
        "icon": "close"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "cart-description"
    }, [_vm._v("\n                            " + _vm._s(item.name) + " -\n                            " + _vm._s(item.description) + "\n                        ")]), _vm._v(" "), _c('div', {
      staticClass: "cart-price"
    }, [_vm._v("\n                            $" + _vm._s(item.price) + "\n                        ")])])
  }), 0), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "button btn-sm btn-primary",
    attrs: {
      "tag": "button",
      "to": {
        name: 'review'
      }
    }
  }, [_vm._v("\n                    Checkout\n                ")])], 1) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "hero-title has-text-centered"
  }, [_vm._v("\n        Customize your"), _c('br'), _vm._v("Gun Mattress\n    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38820a7f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Order.vue
// module id = 214
// module chunks = 1